export const ACCESS_PROPERTY = 'property'
export const ACCESS_OVERVIEW = 'overview'
export const ACCESS_INBOX = 'inbox'
export const ACCESS_BOOKING = 'booking'
export const ACCESS_CALENDAR = 'calendar'
